import React from 'react';
import { Row, Col, CardImg } from 'reactstrap';
import noImage from 'assets/img/users/no-image.jpg';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { useParams } from "react-router-dom";

const CampaignDetails = (props) => {

    const { campaignId } = useParams();

    React.useEffect(() => {
        props.getCampaignsData({ id: campaignId })
    }, [])

    React.useEffect(() => {
        props.getCampaignName((props.campaign && props.campaign.campaign_name) ? props.campaign.campaign_name : '');
    }, [props.campaign])

    const columns = [
        { name: 'campaign_name', label: 'Campaign Name' },
        { name: 'username', label: 'Customer' },
        { name: 'ad_set_name', label: 'Ad set name' },
        { name: 'goal', label: 'Goal' },
        { name: 'target_gender', label: 'Target Gender' },
        { name: 'target_age_minimum', label: 'Target Age Minimum' },
        { name: 'target_age_maximum', label: 'Target Age Maximum' },
        { name: 'target_location', label: 'Target Location' },
        { name: 'target_region', label: 'Target Region' },
        { name: 'interest', label: 'Interest' },
        { name: 'creative_ad_title', label: 'Creative Ad Title' },
        { name: 'creative_ad_url', label: 'Creative Ad Url' },
        { name: 'creative_ad_description', label: 'Creative Ad Description' },
        { name: 'creative_ad_button_name', label: 'Creative Ad Button Name' },
        { name: 'creative_ad_button_color', label: 'Creative Ad Button Color' },
        { name: 'creative_ad_button_text_color', label: 'Creative Ad Button Text Color' },
        //{ name: 'creative_ad_media_path', label: 'Creative Ad Media Path' },
        { name: 'total_ad_budget', label: 'Total Ad Budget' },
        { name: 'ad_start', label: 'Ad Start' },
        { name: 'ad_end', label: 'Ad End' },
        { name: 'totalDuration', label: 'Total Duration' },
        { name: 'payment_type', label: 'Payment Type' },
        { name: 'card_detail_id', label: 'Card Detail Id' },
        { name: 'status', label: 'Status' },
        { name: 'created_at', label: 'Created At' },
        { name: 'updated_at', label: 'Updated At' }
    ]
    return (
        <div>
            <Row>
                <Col sm="12" lg="4" className="profile-image">
                    <CardImg
                        className="card-img-left profile-pic"
                        src={(props.campaign && props.campaign.creative_ad_media_path)?props.campaign.creative_ad_media_path:noImage}
                        style={{ width: 300, height: 300 }}
                    />
                </Col>
                <Col sm="12" lg="8">
                    {columns.map((item) =>
                        <Row key={1}>
                            <Col sm="4" xs="4">
                                {item.label}:
                            </Col>
                            <Col sm="8" xs="8">
                                {(props.campaign && props.campaign[`${item.name}`]) ? props.campaign[`${item.name}`] : ''}
                            </Col>
                        </Row>
                    )}
                </Col>


            </Row>
        </div>
    );
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaign: (state.campaign &&
        state.campaign.details &&
        state.campaign.details.data) ? state.campaign.details.data : [],
});
const mapDispatchToProps = (dispatch) => ({
    getCampaignsData: (payload) => dispatch(CampaignAction.getCampaignsData(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetails);